const locales = require('./locales');
const langs = require('./langs.json');

langs.forEach((lang) => locales.registerLang(lang));

module.exports = locales;
